export function formatDuration(ms) {
  if (!ms || ms <= 0) return '0:00';
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function formatDurationShort(ms) {
  if (!ms || ms <= 0) return '0m';
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
}

export function getTimeBlockLabel(block) {
  switch (block) {
    case 'morning': return 'Morning';
    case 'afternoon': return 'Afternoon';
    case 'evening': return 'Evening';
    default: return '';
  }
}

export function getTimeBlockColor(block) {
  switch (block) {
    case 'morning': return '#F59E0B';
    case 'afternoon': return '#3B82F6';
    case 'evening': return '#8B5CF6';
    default: return '#6B7280';
  }
}

export function getPriorityColor(priority) {
  switch (priority) {
    case 'critical': return '#EF4444';
    case 'high': return '#F97316';
    case 'medium': return '#3B82F6';
    case 'low': return '#6B7280';
    default: return '#6B7280';
  }
}

export function getDayName(dateStr) {
  const date = new Date(dateStr + 'T12:00:00');
  return date.toLocaleDateString('en-US', { weekday: 'long' });
}

export function getShortDate(dateStr) {
  const date = new Date(dateStr + 'T12:00:00');
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function getMinutesLeftInDay() {
  const now = new Date();
  const endOfDay = new Date(now);
  endOfDay.setHours(23, 59, 59, 999);
  return Math.max(0, Math.floor((endOfDay - now) / 60000));
}

export function formatMinutesLeft(minutes) {
  if (minutes <= 0) return '0m';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export function getPriorityGradient(priority) {
  const gradients = {
    critical: ['#FF416C', '#FF4B2B', '#8B0000'],
    high: ['#F97316', '#E65100', '#BF360C'],
    medium: ['#667EEA', '#764BA2', '#2D1B69'],
    low: ['#2C3E50', '#4CA1AF', '#2C3E50'],
  };
  return gradients[priority] || gradients.medium;
}

/**
 * Get today's date as YYYY-MM-DD in LOCAL timezone.
 * Use this instead of new Date().toISOString().split('T')[0] which returns UTC.
 */
export function localToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Convert a Date object or timestamp to YYYY-MM-DD in local timezone.
 */
export function localDateStr(dateOrMs) {
  const d = dateOrMs instanceof Date ? dateOrMs : new Date(dateOrMs || Date.now());
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getPriorityEmoji(priority) {
  switch (priority) {
    case 'critical': return '🔥';
    case 'high': return '⚡';
    case 'medium': return '🎯';
    case 'low': return '🌙';
    default: return '🎯';
  }
}
